import template from './teamRequestCardActions.html';
import controller from './teamRequestCardActions.controller';
import './teamRequestCardActions.scss';

let teamRequestCardActionsComponent = {
  restrict: 'E',
  bindings: {
    request : '<',
    onAccept : '&',
    onReject : '&',
    onDiscard : '&',
    isDisabled: '<'
  },
  template,
  controller
};

export default teamRequestCardActionsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardActions/teamRequestCardActions.component.js